import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=92cc8e84&"
import script from "./user-layout.vue?vue&type=script&lang=js&"
export * from "./user-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports